import React, { useEffect, useState } from "react";
import { Form, Button, Input, InputNumber, Select, Switch, Radio, DatePicker } from "antd";
import { useCheckFormMultiple } from "../../../hooks/useCheckFormMultiple";
import { getTeamAreas } from "../../../types/initStore/initUser";
import { joinArrayServices, typeExtraResource } from "../../../types/typeExtraResource";
import { changeHoursForMinute } from "../../../helpers/changeHours";
import dayjs from "dayjs";
import { ContainerModal } from "../../container/ContainerModal";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";

const initForm = {
	area: [],
	type: [],
	name: [],
	amount: 0,
	currency: "USD",
	hours: 0,
	comment: "",
	startDate: "",
	finishedDate: "",
};

const allAreaTeam = getTeamAreas(["responsible", "comercial", "leader"]);

const allResourceExtras = Object.entries(typeExtraResource).map(([key, value]) => {
	return { name: value, id: key };
});

const allServices = joinArrayServices();

const dateFormat = "YYYY/MM/DD";

export const FomExtraResource = ({ type = 0, dataForm = {}, title = "", editFormForProjectDetails, closeModalDetails }) => {

	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const { checkValues, onChangueValue } = useCheckFormMultiple({
		isAffectsProject: false,
	});

	const [allServicesResource, setAllServicesResource] = useState([]);
	const [activeDateServices, setActiveDateServices] = useState(false);

	useEffect(() => {
		if (type === 0) {
			form.setFieldsValue(initForm);
		} else {
			const { startDate, finishedDate, ...restData } = dataForm;
			onChangueValue("isAffectsProject", typeof restData.area === "string");
			setAllServices(allServices, restData.type);
			form.setFieldsValue({
				...restData,
				startDate: startDate === "" ? "" : dayjs(startDate, dateFormat),
				finishedDate: finishedDate === "" ? "" : dayjs(finishedDate, dateFormat),
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const setAllServices = (allServicesDara = [], value = "") => {
		const getAllServices = allServicesDara.filter((service) => service.father === value);
		setActiveDateServices(value === "SERVIDOR");
		setAllServicesResource(getAllServices);
		form.setFieldsValue({ name: [], dateStart: "", dateFinished: "" });
	};

	const finishForm = async (values) => {
		setLoading(true);
		let newJsonForm = { doesHaveImpact: false };
		Object.entries(values).forEach(([key, value]) => {
			switch (key) {
				case "comment":
					newJsonForm[key] = value === "" ? "-" : value;
					break;
				case "hours":
					newJsonForm.minutes = changeHoursForMinute(value);
					break;
				case "startDate":
				case "finishedDate":
					if (value === "" || value === null) {
						break;
					}
					newJsonForm[key] = value.format("YYYY-MM-DD");
					break;
				default:
					newJsonForm[key] = value;
					break;
			}
		});
		newJsonForm.doesHaveImpact = checkValues["isAffectsProject"];

		if (type === 1) {
			newJsonForm.key = dataForm.key;
		}

        await editFormForProjectDetails(typeForDetailsProyect.hrsExtraResource, { ...newJsonForm, typeEndpoint: type });
        setLoading(false);
	};

	return (
		<>
			<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
				<ContainerModal
					title={title}
					actionButton={() => {
						closeModalDetails();
					}}
					className={"w-[500px]"}
				>
					<Form
						form={form}
						onFinish={finishForm}
						layout="vertical"
						className="w-full flex flex-col"
						onValuesChange={(changedValues, allValues) => {
							const key = Object.keys(changedValues)[0];
							const value = Object.values(changedValues)[0];

							if (key === "type") {
								setAllServices(allServices, value);
							}
						}}
					>
						<div className=" flex items-center gap-4 mb-3">
							<p>Afecta al Proyecto</p>
							<Switch
								checked={checkValues["isAffectsProject"]}
								onChange={(value) => {
									onChangueValue("isAffectsProject", value);
								}}
								className={`${checkValues["isAffectsProject"] ? "bg-primaryTwo" : "bg-[#CDCDCD]"}`}
							/>
						</div>
						{checkValues["isAffectsProject"] && (
							<>
								<Form.Item
									name="area"
									label="Area"
									className="h-[50px]"
									rules={[
										{
											required: true,
											message: "Escoge uno por lo menos",
										},
									]}
								>
									<Select showSearch placeholder={`Area`} className="w-full">
										{allAreaTeam.map((area, index) => (
											<Select.Option key={`${index}-area-team`} value={area}>
												<span style={{ textTransform: "capitalize" }}>{area}</span>
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</>
						)}
						<Form.Item
							name="type"
							label="Recursos Extras"
							className="h-[50px]"
							rules={[
								{
									required: true,
									message: "Escoge uno por lo menos",
								},
							]}
						>
							<Select showSearch placeholder={`Recurso`} className="w-full">
								{allResourceExtras.map((extraResource, index) => {
									let name = extraResource.name;
									if (extraResource.name === "PROVEDOR") {
										name = "PROVEEDOR";
									}
									return (
										<Select.Option key={`${index}-extraresource`} value={extraResource.name}>
											{name}
										</Select.Option>
									);
								})}
							</Select>
						</Form.Item>
						<Form.Item
							name="name"
							label="Tipo de recursos"
							className="h-[50px]"
							rules={[
								{
									required: true,
									message: "Escoge uno por lo menos",
								},
							]}
						>
							<Select showSearch placeholder={`Tipo`} className="w-full" disabled={allServicesResource.length === 0}>
								{allServicesResource.map((servicesResource, index) => (
									<Select.Option key={`${index}-typeextraresource`} value={servicesResource.name}>
										<span style={{ textTransform: "capitalize" }}>{servicesResource.name}</span>
									</Select.Option>
								))}
							</Select>
						</Form.Item>
						{activeDateServices && (
							<div className=" flex gap-4">
								<Form.Item
									name="startDate"
									label="Inicio del servicio"
									className="h-[50px]"
									rules={[
										{
											required: true,
											message: "Escoge uno por lo menos",
										},
									]}
								>
									<DatePicker format={dateFormat} />
								</Form.Item>
								<Form.Item name="finishedDate" label="Fin del servicio" className="h-[50px]">
									<DatePicker format={dateFormat} />
								</Form.Item>
							</div>
						)}
						<div className="flex items-center gap-4">
							<Form.Item name="amount" label="Costo" className="h-[50px]">
								<InputNumber min={0} />
							</Form.Item>
							<Form.Item name="currency" label="Moneda" className="h-[50px]">
								<Radio.Group>
									<Radio.Button value="USD">USD</Radio.Button>
									<Radio.Button value="MXN">MXN</Radio.Button>
								</Radio.Group>
							</Form.Item>
							<Form.Item name="hours" label="Horas" className="h-[50px]">
								<InputNumber min={0} />
							</Form.Item>
						</div>
						<Form.Item name="comment" label="Comentario" className="h-[130px]">
							<Input.TextArea
								placeholder="Comentario"
								autoSize={{
									minRows: 5,
									maxRows: 5,
								}}
								showCount={false}
							/>
						</Form.Item>
						<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
							<Button htmlType="button" onClick={closeModalDetails}>
								Cancelar
							</Button>
							<Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
								Guardar
							</Button>
						</div>
					</Form>
				</ContainerModal>
			</div>
		</>
	);
};
